// extracted by mini-css-extract-plugin
module.exports = {"container":"ap1WPhoYsJl20Euppu6C9","title":"KkqrbBDIAj-QT3jXxWOas","support":"wvXVWYwGu7iqYSGCw-bIV","action":"vo4wzAKyGkQE-kFqqXR6A"};